import Player from '@vimeo/player';

class Video {
    constructor() {
        this.components = document.querySelectorAll('.m-video');

        this.components.forEach((component) => {
            this.init(component);
        });
    }

    init(component) {
        const self = this;
        const button = component.querySelector('.m-video__button');
        const iframe = component.querySelector('.e-video__vimeo iframe');
        const youtube = component.querySelector('.e-video__youtube iframe');
        const video = component.querySelector('video');

        if (iframe) {
            var player = new Player(iframe);

            button.addEventListener('click', function (event) {
                event.preventDefault();

                self.toggleVimeo(player);
            });

            player.on('play', function () {
                button.classList.add('is-hidden');
            });

            player.on('pause', function () {
                button.classList.remove('is-hidden');
            });
        }

        if (video) {
            button.addEventListener('click', function (event) {
                event.preventDefault();

                self.toggleVideo(video, button);
            });
        }
    }

    toggleVimeo(player) {
        player.getPaused().then(function (paused) {
            if (paused) {
                player.play();
            } else {
                player.pause();
            }
        });
    }

    toggleVideo(video, button) {
        if (video.paused || video.ended) {
            video.play();
            button.classList.add('is-hidden');
        } else {
            video.pause();
            button.classList.remove('is-hidden');
        }
    }
}

export default Video;
